import React, { useEffect, useState, useCallback } from 'react';
import Card from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { ressarcimentoStApi } from '../../api/financeiro';
import { COLORS } from '../../theme';
import { useTituloPagina } from '../../context/PageTitleContext';

function formatarReais(v) {
  return (Number(v) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export default function RessarcimentoStList() {
  useTituloPagina('Ressarcimento de ICMS-ST');
  const [dataDe, setDataDe] = useState('');
  const [dataAte, setDataAte] = useState('');
  const [resultado, setResultado] = useState({ uf_origem: null, total_estimado: 0, itens: [] });

  const carregar = useCallback(() => {
    const params = {};
    if (dataDe) params.data_de = dataDe;
    if (dataAte) params.data_ate = dataAte;
    ressarcimentoStApi.listar(params).then(setResultado).catch(() => {});
  }, [dataDe, dataAte]);

  useEffect(() => { carregar(); }, [carregar]);

  return (
    <div>
      <Card style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: 14, borderBottom: `1px solid ${COLORS.border}`, display: 'flex', flexWrap: 'wrap', gap: 14, alignItems: 'end', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'end' }}>
            <Input label="De" type="date" value={dataDe} onChange={e => setDataDe(e.target.value)} style={{ width: 150 }} />
            <Input label="Até" type="date" value={dataAte} onChange={e => setDataAte(e.target.value)} style={{ width: 150 }} />
          </div>
          <div style={{ fontSize: 12, color: COLORS.textMid, maxWidth: 420, textAlign: 'right' }}>
            Vendas para clientes de fora de {resultado.uf_origem || '(defina a empresa padrão)'} com produtos que pagaram ICMS-ST na compra. Valor estimado com base no ICMS-ST cadastrado na Formação de Preço — confirme com o contador antes de protocolar.
          </div>
        </div>

        <div style={{ padding: '10px 14px', background: COLORS.primaryBg, display: 'flex', justifyContent: 'flex-end' }}>
          <span style={{ fontSize: 13 }}>Total estimado de ressarcimento: <strong style={{ color: COLORS.primary }}>{formatarReais(resultado.total_estimado)}</strong></span>
        </div>

        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ textAlign: 'left', background: COLORS.bg }}>
                <th style={{ padding: 10 }}>Data</th>
                <th style={{ padding: 10 }}>Nº Pedido</th>
                <th style={{ padding: 10 }}>Nº NF</th>
                <th style={{ padding: 10 }}>Produto</th>
                <th style={{ padding: 10 }}>Cliente</th>
                <th style={{ padding: 10 }}>UF</th>
                <th style={{ padding: 10 }}>Quantidade</th>
                <th style={{ padding: 10 }}>ST Unitário</th>
                <th style={{ padding: 10 }}>Valor Estimado</th>
              </tr>
            </thead>
            <tbody>
              {resultado.itens.map(item => (
                <tr key={item.id} style={{ borderTop: `1px solid ${COLORS.border}` }}>
                  <td style={{ padding: 10 }}>{new Date(item.data_movimentacao).toLocaleDateString('pt-BR')}</td>
                  <td style={{ padding: 10 }}>{item.pedido_numero ? `#${item.pedido_numero}` : '-'}</td>
                  <td style={{ padding: 10 }}>{item.numero_nota_fiscal || '-'}</td>
                  <td style={{ padding: 10 }}>{item.produto_codigo} - {item.produto_nome}</td>
                  <td style={{ padding: 10 }}>{item.cliente_nome}</td>
                  <td style={{ padding: 10 }}>{item.cliente_uf}</td>
                  <td style={{ padding: 10 }}>{Number(item.quantidade).toLocaleString('pt-BR')}</td>
                  <td style={{ padding: 10 }}>{formatarReais(item.st_unitario)}</td>
                  <td style={{ padding: 10, fontWeight: 700, color: COLORS.primary }}>{formatarReais(item.valor_estimado)}</td>
                </tr>
              ))}
              {resultado.itens.length === 0 && (
                <tr><td colSpan={9} style={{ padding: 20, textAlign: 'center', color: COLORS.textMid }}>Nenhuma venda interestadual com ICMS-ST encontrada no período.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
